<div class="item" [ngClass]="[itemClass]">
  <app-game-icon class="icon" [icon]="item.icon" [inlineIconSize]="true" [class.no-icon]="hideIcon"></app-game-icon>
  <span class="name" [ngxTippy]="tooltip">
    <app-real-name [name]="item.internalId ?? ''"></app-real-name>
  </span>
  <span class="quantity" *ngIf="(item.quantity || 1) > 1">x{{ item.quantity | number }}</span>

  <ng-template #tooltip>
    <app-item-tooltip [item]="item" [showCanClick]="canClick"></app-item-tooltip>
  </ng-template>
</div>
